import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardHeader, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface SkeletonCardProps {
  hasImage?: boolean
  hasStats?: boolean
  statCount?: number
  className?: string
}

export const SkeletonCard = ({
  hasImage = false,
  hasStats = false,
  statCount = 3,
  className,
}: SkeletonCardProps) => {
  return (
    <Card className={cn("overflow-hidden", className)} aria-busy="true" role="status" aria-label="Loading content">
      {hasImage && (
        <Skeleton className="h-48 w-full rounded-none" />
      )}
      <CardHeader>
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-4 w-1/2 mt-2" />
      </CardHeader>
      <CardContent>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6 mt-2" />

        {hasStats && (
          <div className="flex gap-4 mt-6">
            {Array.from({ length: statCount }).map((_, index) => (
              <div key={index} className="flex-1">
                <Skeleton className="h-8 w-16" />
                <Skeleton className="h-3 w-12 mt-2" />
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
